import React from 'react';
import { clearForm } from 'plantItemNew/redux/slices/formSlice';
import { clearReferenceData } from 'plantItemNew/redux/slices/referenceDataSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PagePath } from 'shared/constants/pagePath';
import { clearApplication } from 'shared/redux/applicationSlice';

export const PlantItemNewResetApplication = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(clearForm());
    dispatch(clearApplication());
    dispatch(clearReferenceData());
    navigate(PagePath.holderDetails);
  }, []);

  return <></>;
};
